// extracted by mini-css-extract-plugin
var _1 = "RentalPortalApplicantsBoardCard-moduleRentalPortalApplicantsBoardCard__TBrZt";
var _2 = "RentalPortalApplicantsBoardCard-moduleidentity__mztmO";
var _3 = "RentalPortalApplicantsBoardCard-modulemeta__K9PNd";
export { _1 as "RentalPortalApplicantsBoardCard", _2 as "identity", _3 as "meta" }
